export var isBrowser = typeof window !== 'undefined';
//# sourceMappingURL=isBrowser.js.map